import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {ICalidadNivel} from '../modelos/ICalidadNivel';

@Injectable({
  providedIn: 'root'
})

export class nivelCalidadService {
  
  private diccionarioModulo: any;
  private urlBalanzApi: string;
  private endPointAccion: string;

  constructor(private _util: UtilsService, private _commom: CommonService){
    this.diccionarioModulo = moduloGaritas.url.dobi;
    this.urlBalanzApi = this._util.getUrlBascula();
  }

  setAccion(tipoAccion: string){
    
    switch (tipoAccion) {
      case "obtenerTodo":
        this.endPointAccion = this.urlBalanzApi + this.diccionarioModulo.obtenerTodo;
        break;
      case "crear":
        this.endPointAccion = this.urlBalanzApi + this.diccionarioModulo.crear;
        break;
      case "actualizar":
        this.endPointAccion = this.urlBalanzApi + this.diccionarioModulo.actualizar;
        break;
      case "eliminar":
        this.endPointAccion = this.urlBalanzApi + this.diccionarioModulo.eliminar;
        break;
    }
    
    return this.endPointAccion;
  }

//this.urlBalanzApi + this.diccionarioModulo.obtenerTodo
  obtener(): Observable<any[]> {
    let solicitud = this.setAccion("obtenerTodo");
    return this._commom.peticionGetConHeader(solicitud);
  }

  obtenerPorId(idRegistro: number): Observable<any> {
    let solicitud = this.setAccion("obtenerPorId") + idRegistro
    return this._commom.peticionGetConHeader(solicitud);
  }

  crear(request: ICalidadNivel) {
    let solicitud = this.setAccion("crear");
    return this._commom.peticionPostConHeader(solicitud, request);
  }

  editar(request: ICalidadNivel) {
    let solicitud = this.setAccion("actualizar");
    return this._commom.peticionPutConHeader(solicitud, request);
  }

  borrar(request: ICalidadNivel): Observable<any> {
    let solicitud = this.setAccion("eliminar");
    return this._commom.peticionDeleteConHeader(solicitud, request);
  }

}
